/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AuthorizedEntity,
    AuthorizedEntityFromJSON,
    AuthorizedEntityFromJSONTyped,
    AuthorizedEntityToJSON,
} from './AuthorizedEntity';

/**
 * 
 * @export
 * @interface CarePrincipalAccess
 */
export interface CarePrincipalAccess {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalAccess
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {Array<AuthorizedEntity>}
     * @memberof CarePrincipalAccess
     */
    systemEntities?: Array<AuthorizedEntity>;
    /**
     * 
     * @type {Array<AuthorizedEntity>}
     * @memberof CarePrincipalAccess
     */
    careProviderEntities?: Array<AuthorizedEntity>;
}

export function CarePrincipalAccessFromJSON(json: any): CarePrincipalAccess {
    return CarePrincipalAccessFromJSONTyped(json, false);
}

export function CarePrincipalAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalAccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'systemEntities': !exists(json, 'systemEntities') ? undefined : ((json['systemEntities'] as Array<any>).map(AuthorizedEntityFromJSON)),
        'careProviderEntities': !exists(json, 'careProviderEntities') ? undefined : ((json['careProviderEntities'] as Array<any>).map(AuthorizedEntityFromJSON)),
    };
}

export function CarePrincipalAccessToJSON(value?: CarePrincipalAccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carePrincipalId': value.carePrincipalId,
        'systemEntities': value.systemEntities === undefined ? undefined : ((value.systemEntities as Array<any>).map(AuthorizedEntityToJSON)),
        'careProviderEntities': value.careProviderEntities === undefined ? undefined : ((value.careProviderEntities as Array<any>).map(AuthorizedEntityToJSON)),
    };
}

